<p>
  This <b>irreversibly</b> removes the entire custom domain configuration for
  account <b>{{ accountId }}</b
  >. There is no undo.
</p>
<p>
  Emails and SMS sent by this customer after this removal will not use any
  custom domain for the links and landing pages.
</p>
<p>Remember to also remove the related infrastructure.</p>
<p>Are you sure?</p>
<div class="buttons">
  <button class="btn btn-outline-dark" (click)="cancel()">Cancel</button>
  <button class="btn btn-success" (click)="confirm()">
    <i class="fas fa-check"></i> <span>Confirm</span>
  </button>
</div>
